<template>
  <div
    :class="`collapsable-menu ${chevronActive ? '' : 'borderNone'}`"
    style="
      background: var(--UI-white, #fff);
      box-shadow: 5px 0px 15px 0px rgba(167, 167, 167, 0.1);
      position: relative;
      z-index: 1;
    "
  >
    <div :class="`menu ${isMenuOpen ? 'expand' : ''}`">
      <div id="titleCollapsableMenu" class="title">
        {{ sectionTitle }}
      </div>
      <div v-if="!menuItems[0].description" class="menu_items tw-max-w-[220px]">
        <div
          v-for="(item, index) in menuItems"
          :key="index"
          :class="`${
            selectedMenuKeys[`level0`].id === item.id ? 'active' : ''
          } menu_item_wrapper tw-cursor-pointer `"
        >
          <a
            :href="
              isCheckSubscription(item?.title) ? urlSubscription : item.url
            "
            class="!tw-no-underline"
            :class="item?.title"
          >
            <collapsable-menu-item
              :menu-item="item"
              :index="index"
              :level="0"
              :is-selected="selectedMenuKeys[`level0`].id === item.id"
              :danger="item.danger"
              @select-item="selectItem"
              @leaf-item-selected="() => handleLeafItemSelect(item)"
              @click.prevent="onClickMenuItem(item)"
            />
          </a>

          <div
            v-show="selectedMenuKeys[`level0`].id === item.id"
            v-if="item.children && item.children?.length > 0"
            class="level-1_wrapper"
          >
            <a
              v-for="(subitem, subIndex) in item.children"
              :key="subitem.id"
              :href="subitem.url"
              class="level-1_items !tw-no-underline"
            >
              <collapsable-menu-item
                :menu-item="subitem"
                :index="subIndex"
                :level="1"
                :is-selected="selectedMenuKeys[`level1`].id === subitem.id"
                @select-item="selectItem"
                @leaf-item-selected="() => handleLeafItemSelect(subitem)"
              />
              <div
                v-show="selectedMenuKeys[`level1`].id === subitem.id"
                v-if="subitem.children && subitem.children?.length > 0"
                class="level-2_wrapper"
              >
                <div
                  v-for="(leafItem, leafIndex) in subitem.children"
                  :key="leafItem.id"
                  style="overflow: hidden"
                  class="level-2_items"
                >
                  <collapsable-menu-item
                    :menu-item="leafItem"
                    :index="leafIndex"
                    :level="2"
                    :is-selected="selectedMenuKeys[`level2`].id === leafItem.id"
                    @select-item="selectItem"
                    @leaf-item-selected="() => handleLeafItemSelect(leafItem)"
                    @click="onClickMenuItem(item)"
                  />
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
      <div v-else class="menu_items tw-max-w-[220px]">
        <div
          v-if="menuItems[0].logo"
          class="tw-bg-[#E4F1FF] tw-w-[190px] tw-py-[14px] tw-flex tw-items-center tw-justify-center tw-mx-[15px] tw-mb-[20px] tw-rounded-[4px]"
        >
          <component :is="menuItems[0].logo" />
        </div>
        <p
          class="tw-mb-[20px] tw-whitespace-pre-line tw-text-[#211F58] tw-text-[11px] tw-not-italic tw-font-medium tw-leading-[135%] tw-pt-[1px] tw-px-[15px] tw-w-[220px]"
        >
          {{ menuItems[0].description }}
        </p>
        <p
          v-if="menuItems[0].instruction"
          class="tw-mb-[0] tw-whitespace-pre-line tw-text-[#878787] tw-text-[11px] tw-not-italic tw-font-normal tw-leading-[135%] tw-pb-[16px] tw-px-[15px] tw-w-[220px]"
        >
          <span class="tw-font-semibold">{{
            menuItems[0].instructionTitle
          }}</span>
          <br />
          <span>{{ menuItems[0].instruction }}</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Ref, reactive, ref } from "vue";
import { Component, Prop, Vue, Watch } from "vue-facing-decorator";
import CollapsableMenuItem from "@/components/common/collapsibleMenuItem.vue";
import { CollapsableMenuItemType } from "@/components/common/collapsibleMenuItem.vue";
import { routers } from "@/utils/constants";
import store from "@/store";
import { getComponentUiText } from "@/utils/utilities";
import { getSessionPortal } from "@/services/subscriptions";
import { showErrorAPI } from "@/services/apiRoutes";
import { Subscription } from "@/services/apiRoutes/routes";

@Component({
  components: {
    CollapsableMenuItem: CollapsableMenuItem,
  },
})
export default class CollapsableMenu extends Vue {
  @Prop({ required: true }) readonly menuItems: Array<CollapsableMenuItemType> =
    [];
  @Prop({ required: false }) readonly menuUrl: string = "";
  @Prop({ default: false }) readonly isMenuOpen: boolean = false;
  @Prop({ default: () => {} }) readonly setForcedActive: any = () => {};
  @Prop({ default: "" }) readonly sectionTitle: string = "";
  @Prop({ default: "" }) readonly sectionSubTitle: string = "";
  @Prop({ default: -1 }) readonly primaryMenuIndex: number = -1;

  public selectedItemId: string | Ref = ref("");

  // selected index for each level
  public selectedMenuKeys = reactive({
    level0: { id: "", title: "" },
    level1: { id: "", title: "" },
    level2: { id: "", title: "" },
  });

  public urlSubscription: any = ref("");

  isCheckSubscription(title: string) {
    return (
      title === getComponentUiText("app-menu-submenu-settings-subscription-1")
    );
  }

  @Watch("menuItems")
  onMenuItemsChanged() {
    if (this.menuItems && this.menuItems.length === 0)
      this.handleNavigateToPage();
  }

  async mounted() {
    try {
      const data = await getSessionPortal("dashboard");
      this.urlSubscription = data.data.data.redirectUrl;
    } catch (error) {
      // showErrorAPI(error, Subscription.getSessionPortal);
    }
  }

  public toggleMenu() {
    this.$emit("setIsMenuOpen");
  }

  public onClickMenuItem(item) {
    if (item.url === routers.settingsSetup) {
      store.dispatch("SetupWizard/onModalSetupWizard", true);
    }
  }

  get chevronActive() {
    return store.state.Navigation.isMenuOpen;
  }

  public async selectItem(
    level: number,
    id: string,
    title: string,
    parentTitle: string,
    index: number,
    parentId?: string,
    forceSetHierarchy?: boolean,
  ) {
    if (
      title === getComponentUiText("app-menu-submenu-settings-subscription-1")
    ) {
      try {
        const clientSecretResponse = await getSessionPortal("dashboard");
        const sessionPortalUrl =
          clientSecretResponse.data?.data?.redirectUrl || "";
        if (!sessionPortalUrl) {
          showErrorAPI("app-settings-subscription-error-text-1", "error");
          return;
        }
        window.location.href = sessionPortalUrl;
        return;
      } catch (error) {
        // showErrorAPI(error, Subscription.getSessionPortal);
      }
    }
    store.dispatch("Navigation/setActiveHierarchyIndex", {
      level: 0,
      index: this.primaryMenuIndex,
    });
    store.dispatch("Navigation/setActiveHierarchyIndex", {
      level: level + 1,
      index,
    });
    if (this.selectedMenuKeys[`level${level}`].id === id) {
      this.selectedMenuKeys[`level${level}`].id = -1;
    } else {
      this.selectedMenuKeys[`level${level}`].id = id;
      this.selectedMenuKeys[`level${level}`].title = title;
      if (parentId) {
        let titleList: string[] = [];
        titleList = parentTitle.split("-");
        parentId.split("-").forEach((parentId, index) => {
          this.selectedMenuKeys[`level${index}`].id = parentId;

          this.selectedMenuKeys[`level${index}`].title = titleList[index];
        });
      }
      if (forceSetHierarchy)
        this.$emit("set-active-hierarchy", this.selectedMenuKeys);
    }
  }

  public handleLeafItemSelect(item: any) {
    if (item?.url) {
      this.toggleMenu();
    }
    this.$emit("set-active-hierarchy", this.selectedMenuKeys);
  }

  private handleNavigateToPage() {
    const defaultMenuKeys = reactive({
      level0: { id: "", title: "" },
      level1: { id: "", title: "" },
      level2: { id: "", title: "" },
    });

    this.selectedMenuKeys = defaultMenuKeys;
    this.selectedMenuKeys.level0.id = "";
    this.selectedMenuKeys.level0.title = this.sectionSubTitle;

    this.$router.push({ path: this.menuUrl });
    this.$emit("set-active-hierarchy", this.selectedMenuKeys);
  }
}
</script>

<style scoped>
.collapsable-menu {
  max-width: 221px;
  height: 100%;
  display: flex;
  /* filter: drop-shadow(2px 0px 15px rgba(0, 0, 0, 0.05)); */
  overflow: hidden;
  border-right: 1px solid var(--UI-rule, #eff0f1);
}

.primary-menu-index {
  z-index: none;
}

.borderNone {
  border: none;
}

.collapsable-menu:has(.menu.expand) {
  width: 100%;
  border-right: 1px solid #eff0f1;
}

.collapsable-menu .menu {
  width: 0px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: 8px;
  border: none;
  transition: width 0.15s ease-in-out;
  /* margin-top: 26px; */
}

.collapsable-menu .menu .menu_items {
  /* border-top: 1px solid rgb(224, 224, 224, 0.5); */
  padding: 16px 0;
}

.collapsable-menu .menu.expand {
  width: 220px;
}

.collapsable-menu .menu:not(.expand) > * {
  visibility: hidden;
}

.collapsable-menu .menu .title {
  font-family: "Poppins";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 16px;
  width: 100%;
  height: fit-content;
  /* identical to box height */

  /* brand/Navy */

  color: #211f58;
  padding: 26px 15px 0;
}

.menu_item_wrapper:first-child {
  border-top: 1px solid rgb(224, 224, 224, 0.5);
}

.menu_item_wrapper {
  border-bottom: 1px solid rgb(224, 224, 224, 0.5);
  width: 220px;
}

.level-1_wrapper {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.level-1_items {
  width: 100%;
  word-wrap: break-word;
  display: flex;
  flex-direction: column;
}

.level-1_items:last-child {
  padding-bottom: 15px;
}

.level-2_wrapper {
  padding: 0px 0px 0px 0px;
}

.level-2_items {
  width: 100%;
  word-wrap: break-word;
  padding: 15px 0px 0px 26px;
  display: flex;
  flex-direction: column;
  text-align: left;
}

.menu_item_wrapper:hover {
  background: rgba(242, 248, 255, 1);
}

.menu_item_wrapper:active {
  background: rgba(228, 241, 255, 1);
}

.menu_item_wrapper.active {
  background: #fcfcfd;
}
</style>
